module.exports = __webpack_public_path__ + "img/season.44d068b4.jpg";